module.exports = __webpack_public_path__ + "img/Nikkei.be4f5da0.jpg";